import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

import { ReactComponent as VideoPause } from '@/assets/icons/videoPause.svg';
import { ReactComponent as VideoPlay } from '@/assets/icons/videoPlay.svg';

export const CloseButton = styled(Box)`
  cursor: grab;
  top: 5px;
  right: 5px;
  position: absolute;
  z-index: 10;
`;
export const VideoBox = styled(Box)<{
  $currentTime?: number;
  $isEnded?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  ${({ $currentTime }) =>
    $currentTime !== 0 &&
    css`
      z-index: 1;
    `}
  ${({ $isEnded }) =>
    !!$isEnded &&
    css`
      z-index: unset;
    `}
`;
export const PlayerVideo = styled.video<{
  $desktopAspectRatio?: { x: number; y: number };
  $mobileAspectRatio?: { x: number; y: number };
  controls?: boolean;
}>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin: 0 auto;
  ${({ $mobileAspectRatio }) =>
    $mobileAspectRatio &&
    css`
      aspect-ratio: ${$mobileAspectRatio.x} / ${$mobileAspectRatio.y};
    `}
  ${({ $desktopAspectRatio, theme }) =>
    $desktopAspectRatio &&
    css`
      ${theme.media.md.up} {
        aspect-ratio: ${$desktopAspectRatio.x} / ${$desktopAspectRatio.y};
      }
    `}

  ${({ controls }) =>
    !controls &&
    css`
      pointer-events: none;
    `}
`;
export const VideoActionButton = styled.button`
  background: transparent;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 0;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 3;
`;

export const VideoPlayIcon = styled(VideoPlay)`
  &:hover {
    path:nth-child(2) {
      fill: ${({ theme }) => theme.colors?.primary};
      transition: fill 0.3s;
    }
    path:nth-child(1) {
      stroke: ${({ theme }) => theme.colors?.primary};
      transition: stroke 0.3s;
    }
  }
`;

export const VideoPauseIcon = styled(VideoPause)`
  &:hover {
    rect {
      fill: ${({ theme }) => theme.colors?.primary};
      transition: fill 0.3s;
    }
    path {
      stroke: ${({ theme }) => theme.colors?.primary};
      transition: stroke 0.3s;
    }
  }
`;
export const StyledPlayAndPauseButton = styled.button`
  cursor: grab;
  background-color: #ddd;
  border: none;
  border-radius: 0;
  color: #000;
  flex: 1 auto;
  margin: 0;
  outline: none;
  padding: 0;
  text-align: center;
  width: 3rem;
  border-bottom-left-radius: 0.2em;
  border-top-left-radius: 0.2em;
`;
